module.exports = __webpack_public_path__ + "img/total-payments-icon.210a104e.svg";